import React, { useRef } from "react";
import AutoScroll from "embla-carousel-auto-scroll";
import useEmblaCarousel from "embla-carousel-react";
import { sectionFrame } from "../../config/site";
import { sponsorLogos } from "../../content/site";

export function PartnersSection() {
    const autoScroll = useRef(
        AutoScroll({
            direction: "forward",
            playOnInit: true,
            speed: 0.9,
            startDelay: 0,
            stopOnInteraction: false,
            stopOnMouseEnter: false,
            stopOnFocusIn: false,
        })
    );
    const [emblaRef] = useEmblaCarousel(
        {
            align: "start",
            dragFree: true,
            loop: true,
        },
        [autoScroll.current]
    );

    return (
        <section
            id="partners"
            className="mt-[110px] flex flex-col gap-8 max-[639px]:mt-[84px] max-[639px]:gap-5"
            aria-label="Спонсоры конференции"
        >
            <div className={sectionFrame}>
                <h2 className="m-0 text-[56px] font-bold uppercase leading-none tracking-[-0.04em] text-white max-[639px]:text-[31px] max-[639px]:leading-[1]">
                    Спонсоры конференции
                </h2>
            </div>
            <div
                ref={emblaRef}
                className="h-[200px] overflow-hidden bg-accent max-[639px]:h-[103px]"
                aria-label="Спонсоры конференции"
            >
                <div className="flex h-full touch-pan-y select-none items-center -ml-[96px] max-[639px]:-ml-[54px]">
                    {sponsorLogos.map((logo, index) => (
                        <div
                            key={`${logo.src}-${index}`}
                            className="flex h-full min-w-0 flex-[0_0_auto] items-center pl-[96px] max-[639px]:pl-[54px]"
                        >
                            <img
                                src={logo.src}
                                alt={logo.alt}
                                width={logo.width}
                                height={logo.height}
                                className="block h-auto max-h-[108px] w-auto max-w-none shrink-0 max-[639px]:max-h-[58px]"
                                decoding="async"
                                draggable={false}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
